import { SiteControlEvent } from '@scaleaq/sitecontrol-lib';

export function getEventField(
  event: SiteControlEvent,
  key: keyof SiteControlEvent | string
): string {
  const value = (event as unknown as Record<string, unknown>)[key];
  return value?.toString().toLowerCase() ?? '';
}
